import { Plus, ServerCrash } from "lucide-react";
import type { AgentRole } from "@paperclip-cloud/shared";
import { DeviceCard } from "./DeviceCard";
import type { Device } from "../api/queries/devices";
import { useUiStore } from "../stores/ui";

export interface FleetGridProps {
  devices: Device[];
  loading?: boolean;
  /** Roles each device hosts, indexed by device id. */
  rolesByDeviceId?: Record<string, AgentRole[]>;
}

export function FleetGrid({ devices, loading, rolesByDeviceId }: FleetGridProps) {
  const setPair = useUiStore((s) => s.setPairModalOpen);

  if (loading) {
    return (
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className="card h-[120px] animate-pulse"
            aria-hidden="true"
          />
        ))}
      </div>
    );
  }

  if (devices.length === 0) {
    return (
      <div className="card flex flex-col items-center gap-3 px-6 py-12 text-center">
        <ServerCrash size={28} className="text-tertiary" aria-hidden="true" />
        <div className="text-[15px] font-semibold text-primary">No computers yet</div>
        <p className="max-w-xs text-[13px] text-secondary">
          Pair your first computer to start dispatching work from the CEO chat.
        </p>
        <button className="btn btn--primary mt-2" onClick={() => setPair(true)}>
          <Plus size={14} />
          Add computer
        </button>
      </div>
    );
  }

  return (
    <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
      {devices.map((d) => (
        <DeviceCard key={d.id} device={d} hostedRoles={rolesByDeviceId?.[d.id]} />
      ))}
    </div>
  );
}
